import BaseClient from '@/app/model/api/response/baseApiClient'

class FieldOrderApi extends BaseClient {
  public getFieldOrderData (bodyData: any) {
    const path = '/v1/field/order'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    if (bodyData.year !== null) {
      params.append('year', bodyData.year)
    }

    for (var i in bodyData.season) {
      params.append('season[]', String(bodyData.season[i]))
    }

    for (var j in bodyData.harvestStatus) {
      params.append('harvest_status[]', String(bodyData.harvestStatus[j]))
    }

    if (bodyData.flag) {
      if (bodyData.variety !== null) {
        params.append('variety_id', bodyData.variety)
      }

      if (bodyData.grade !== null) {
        params.append('grade_id', bodyData.grade)
      }

      if (bodyData.word !== '') {
        params.append('word', bodyData.word)
      }
    }

    // ページネーション
    params.append('page_num', String(bodyData.page))

    // 並び替え
    if (bodyData.order !== '') {
      params.append('order_num', String(bodyData.order))
      params.append('sort', bodyData.sort)
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new FieldOrderApi()
